
































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import BaseTitle from "./base-title.vue";
import IOrderInformation from "./order-information.vue";
import { IOrderDto } from "../../../types/interface/IOrderDto";
import { DeliveryType } from "../../../types/enum/OrderEnum";
import { IUserDeliveryInformationDto } from "../../../types/interface/IUserInfoDto";
import { IOrderParkingLotDto } from "../../../types/interface/IOrderParkingLotDto";
import { toLocalTime, Operatore } from "../../../api/net/util";
@Component({
  components: {
    BaseTitle
  }
})
export default class OrderInformation extends Vue {
  @Prop({ default: [] }) order!: IOrderDto;

  public get icon(): string {
    return this.order.deliveryType === DeliveryType.Delivery
      ? "mdi-truck-fast-outline"
      : "mdi-parking";
  }

  public get title(): string {
    return this.order.deliveryType === DeliveryType.Delivery
      ? "Delivery Information"
      : "Drive-thru Information";
  }

  public get isShowDeliveryInfomation(): boolean {
    return this.order.deliveryType === DeliveryType.Delivery;
  }

  public get isShowDriveThruInformation(): boolean {
    return (
      this.order.deliveryType === DeliveryType.Pickup &&
      !!this.order.orderParkingLotPickupFieldValues.length
    );
  }

  public get deliveryInformation(): IUserDeliveryInformationDto {
    const {
      address: {
        contact,
        phone,
        postalCode,
        gateCode,
        address1,
        apartmentNumber,
        deliveryNotes
      }
    } = this.order;
    let deliveryInformation: IUserDeliveryInformationDto = {
      Contact: contact,
      Phone: phone,
      Address: `${address1} ${postalCode}`,
      GateCode: gateCode as string,
      ApartmentNumber: apartmentNumber as string,
      DeliveryNotes: deliveryNotes as string
    };
    return deliveryInformation;
  }

  public get parkingLot(): IOrderParkingLotDto[] {
    let parkingLotInfo: IOrderParkingLotDto[] = JSON.parse(
      JSON.stringify(this.order.orderParkingLotPickupFieldValues)
    );
    return parkingLotInfo.sort(
      (a: IOrderParkingLotDto, b: IOrderParkingLotDto) => {
        return a.name.substring(0, 1).toUpperCase() >
          b.name.substring(0, 1).toUpperCase()
          ? -1
          : a.name.substring(0, 1).toUpperCase() <
            b.name.substring(0, 1).toUpperCase()
          ? 1
          : 0;
      }
    );
  }

  public get customerArrivedDate(): string {
    if (this.order.customerArrivedDate) {
      return toLocalTime(
        `${this.order.customerArrivedDate}`,
        Operatore.Horizontal
      );
    } else {
      return "";
    }
  }
}
